import {buildUrl} from "../service/url-builder";
const axios = require('axios');

function getUsedConfig(runContext){
    return axios.get(buildUrl("/referenceData"), {
        params: {
            dataSet: "usedConfig",
            runContext:runContext
        }
    }).then(response => {
        return response.data;
    });
}

function getAllConfig(){
    return axios.get(buildUrl("/referenceData"), {
        params: {
            dataSet: "config"
        }
    }).then(response => {
        return response.data;
    });
}

export {getUsedConfig, getAllConfig}